import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { StorageKeys } from 'src/app/model/enums/storage-keys';
import { SleekNoteMessage } from 'src/app/model/interfaces/sleeknote-message';
import { PlayerService, StorageService } from 'src/app/services';
import { PopupService } from 'src/app/services/pop-up.service';

@Component({
  selector: 'app-sleek-note',
  templateUrl: './sleek-note.component.html',
  styleUrls: ['./sleek-note.component.scss']
})
export class SleekNoteComponent implements OnInit, OnDestroy
{
    public sleeknotes: SleekNoteMessage[] = []; 
    public priorityNotes: SleekNoteMessage[] = [];
    public loginNotes: SleekNoteMessage[] = []; 
    public loggedIn: boolean;
    
    private currentNotes: SleekNoteMessage[] = [];
    private messagesRead: string[];
    private currentPath: string;
    private routerSubscription = new Subscription();
    private readonly router: Router;
    private readonly playerService: PlayerService;
    private readonly popupService: PopupService;
    private readonly storageService: StorageService;

    public constructor(
      router: Router, 
      playerService: PlayerService, 
      popupService: PopupService, 
      storageService: StorageService)
    { 
        this.router = router;
        this.playerService = playerService;
        this.popupService = popupService;
        this.storageService = storageService;
    }

    public ngOnInit(): void 
    {
        this.messagesRead = this.storageService.getItem<string[]>(StorageKeys.SleetNotesRead) || [];

        this.getMessages();
        this.currentPath = this.router.url;
        
        this.setURLlistener();
    }

    public close(noteType : string): void 
    {
        // set or add id and save to Session Storage
        if (noteType == "priority")
        {
            this.messagesRead.push(this.priorityNotes[0].Id);
        }
        else if (noteType == "login")
        {
            this.messagesRead.push(this.loginNotes[0].Id);
        }
        else
        {
            this.messagesRead.push(this.sleeknotes[0].Id);
        }

        this.storageService.setItem(StorageKeys.SleetNotesRead, this.messagesRead);
        this.showNextNote();
    }

    public showNextNote(): void
    {
        this.sleeknotes = this.currentNotes.filter( (item) => { 

            if (this.messagesRead.includes(item.Id) || item.ShowOnlyOnURL.length > 0 || item.ShowOnlyIfLoggedIn)
            {
                return false;
            }
            else
            {
                return true
            }  
        });

        this.loginNotes = this.currentNotes.filter( (item) => {

            if (this.messagesRead.includes(item.Id) || item.ShowOnlyOnURL.length > 0)
            {
                return false;
            }
            else
            {
              if (item.ShowOnlyIfLoggedIn && this.loggedIn)
              {
                return true;
              }
              else
              {
                return false;
              }
            }
        });

        this.priorityNotes = this.currentNotes.filter( (item) => { 
          
            if (this.messagesRead.includes(item.Id))
            {
                return false;
            }
            else if (item.ShowOnlyOnURL.includes(this.currentPath))
            {
                if (item.ShowOnlyIfLoggedIn && !this.loggedIn)
                {
                    return false;
                } 
                else
                { 
                    return true;
                }
            }
            else
            {
                return false;
            }
        });
    }

    private setURLlistener(): void 
    {
        this.routerSubscription = this.router.events.pipe(
          filter((event: any) => event instanceof NavigationEnd))
          .subscribe((event =>
          {
              this.currentPath = event.url;
              this.fetchLoginInformations();
              this.showNextNote();
          }));
    }

    public getMessages(): void 
    {
        this.popupService.getPopUpMessage().subscribe((messages) => {
            this.currentNotes = messages;
        });
    }

    public onCtaClick(message: SleekNoteMessage, noteType: string): void
    {
        this.close(noteType);
        if(message.CtaType != 'none')
        {
            setTimeout(() => {
                this.popupService.triggerMessageCta(message);
            }, 0);
        }
    }

    private fetchLoginInformations(): void
    {
        this.playerService.getAuthorizedObservable().subscribe((isAuthorized) => {
            if (isAuthorized)
            {
                this.loggedIn = true;
            }
            else
            {
              this.loggedIn = false;
            }
        });
    }

    public ngOnDestroy(): void
    {
        this.routerSubscription.unsubscribe();
    }
}
